import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userDeviceNotificationMessages = {
  [AutomationEventTypes.DeviceConnected]: {
    subject: 'New Device Connected *|DEVICE:NAME|*',
    message: `
      Hi Team,

      We wanted to inform you that a new device has been connected. Please find the details below:

      Device Details:
      Name: *|DEVICE:NAME|*
      `,
  },
  [AutomationEventTypes.DeviceAccessCreated]: {
    subject: 'Smart Lock Code generated for *|GUEST:NAME|* for *|RENTAL:NAME|*',
    message: `
      Hi Team,

      A smart lock code has been generated and sent to the guest. Please find the details below:

      Rental Details:
      Rental Name: *|RENTAL:NAME|*
      Guest Name: *|GUEST:NAME|*
      Check-in Date: *|INQUIRY:ARRIVE|*
      Check-out Date: *|INQUIRY:DEPART|*
      `,
  },
  [AutomationEventTypes.DeviceAccessUpdated]: {
    subject: 'Smart Lock Code updated for *|GUEST:NAME|* for *|RENTAL:NAME|*',
    message: `
      Hi Team,

      The smart lock code has been updated and sent to the guest. Please find the updated details below:

      Rental Details:
      Rental Name: *|RENTAL:NAME|*
      Guest Name: *|GUEST:NAME|*
      Check-in Date: *|INQUIRY:ARRIVE|*
      Check-out Date: *|INQUIRY:DEPART|*
      `,
  },
  [AutomationEventTypes.DeviceCodeFirstUsed]: {
    subject: 'Device *|DEVICE:NAME|*code is used first time',
    message: `
      Hi Team,

      The guest has used the smart lock code for the first time. Please find the details below:

      Rental Details:
      Rental Name: *|RENTAL:NAME|*
      Guest Name: *|GUEST:NAME|*
      Check-in Date: *|INQUIRY:ARRIVE|*
      Check-out Date: *|INQUIRY:DEPART|*
      `,
  },
  [AutomationEventTypes.DeviceLowBattery]: {
    subject: 'Device *|DEVICE:NAME|* battery is low',
    message: `
      Hi Team,

      The battery for smart device *|DEVICE:NAME|* is low. Please replace or recharge the batteries as needed.
      `,
  },
  [AutomationEventTypes.DeviceIssuesRequireAttention]: {
    subject: 'Device *|DEVICE:NAME|* is not functional',
    message: `
      Hi Team,

      There seems to be an issue with the device *|DEVICE:NAME|* at *|RENTAL:NAME|*. Please check the device configuration and investigate further.
      `,
  },
}

export const guestDeviceNotificationMessages = {
  [AutomationEventTypes.DeviceAccessCreated]: {
    subject: 'Your Smart Lock Code for *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      Welcome to *|RENTAL:NAME|*! To ensure a smooth check-in process, we’ve set up a smart lock for your stay. Below are the details you’ll need to access the property:

      Smart Lock Details:
      Your Smart Lock Code: *|DEVICE:CODE|*
      Device Name: *|DEVICE:NAME|*

      Instructions:
      Enter the code above using the keypad.
      Press the [Enter/Checkmark/Unlock] button to unlock the door.
      Please note: This code is unique to your reservation and will expire after your checkout date, *|INQUIRY:DEPART|*.

      We hope you have a wonderful stay! If you need any assistance, please don’t hesitate to reach out.
    `,
  },
  [AutomationEventTypes.DeviceAccessUpdated]: {
    subject: 'Your updated Smart Lock Code for *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We are excited to welcome you to *|RENTAL:NAME|*! Please note that your smart lock code has been updated, and the previous code is no longer valid. Below are the updated details you’ll need to access the property:

      Smart Lock Details:
      Your Updated Smart Lock Code: *|DEVICE:CODE|*
      Device Name: *|DEVICE:NAME|*

      Instructions:
      Enter the code above using the keypad.
      Press the [Enter/Checkmark/Unlock] button to unlock the door.
      Please note: This code is unique to your reservation and will expire after your checkout date, *|INQUIRY:DEPART|*.

      We hope you have a wonderful stay! If you need any assistance, please don’t hesitate to let us know.
    `,
  },
  [AutomationEventTypes.DeviceIssuesRequireAttention]: {
    subject: 'Device *|DEVICE:NAME|* is not functional',
    message: `
      Dear *|GUEST:NAME|*,

      We wanted to inform you that there is an issue with the device *|DEVICE:NAME|* at *|RENTAL:NAME|*. Our team is working on resolving the problem as quickly as possible.

      We apologize for any inconvenience this may have caused and appreciate your understanding.
    `,
  },
}
